var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYoutubeDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.3195 4.60803C7.34319 4.33291 7.58543 4.12908 7.86055 4.15277C8.8352 4.2367 9.62224 4.53866 10.1484 5.18714C10.6634 5.82181 10.8527 6.69764 10.8527 7.75593V7.82093C10.8527 8.98788 10.622 9.93489 9.97933 10.5776C9.33662 11.2203 8.38961 11.4509 7.22266 11.4509H3.96766C2.80071 11.4509 1.85369 11.2203 1.21098 10.5776C0.568265 9.93489 0.337656 8.98788 0.337656 7.82093V7.75593C0.337656 6.70528 0.524377 5.83495 1.03097 5.20171C1.54913 4.55401 2.32494 4.2477 3.28625 4.15809C3.5612 4.13246 3.80487 4.33457 3.8305 4.60952C3.85613 4.88447 3.65402 5.12814 3.37906 5.15377C2.57037 5.22916 2.09868 5.46784 1.81184 5.8264C1.51344 6.19941 1.33766 6.79657 1.33766 7.75593V7.82093C1.33766 8.88898 1.55455 9.50696 1.91808 9.8705C2.28162 10.234 2.89961 10.4509 3.96766 10.4509H7.22266C8.29071 10.4509 8.90869 10.234 9.27223 9.8705C9.63577 9.50696 9.85266 8.88898 9.85266 7.82093V7.75593C9.85266 6.78921 9.67441 6.19005 9.37189 5.81722C9.08057 5.45819 8.60012 5.22016 7.77476 5.14908C7.49964 5.12539 7.29581 4.88315 7.3195 4.60803Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.59766 0.700928C5.8738 0.700928 6.09766 0.924785 6.09766 1.20093V7.64093C6.09766 7.91707 5.8738 8.14093 5.59766 8.14093C5.32151 8.14093 5.09766 7.91707 5.09766 7.64093V1.20093C5.09766 0.924785 5.32151 0.700928 5.59766 0.700928Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5691 6.17237C3.76436 5.97711 4.08095 5.97711 4.27621 6.17237L5.59766 7.49382L6.9191 6.17237C7.11436 5.97711 7.43095 5.97711 7.62621 6.17237C7.82147 6.36764 7.82147 6.68422 7.62621 6.87948L5.95121 8.55448C5.75595 8.74974 5.43936 8.74974 5.2441 8.55448L3.5691 6.87948C3.37384 6.68422 3.37384 6.36764 3.5691 6.17237Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeDownload);
export default __webpack_public_path__ + "static/media/youtubeDownload.fc9c874d.svg";
export { ForwardRef as ReactComponent };